module.exports = __webpack_public_path__ + "static/media/cucumber_blog.78697827.webp";